export const appBaseURL =
  process.env.REACT_APP_BACKEND_URL ||
  'https://backend-app.staging.svc.avenue8.com'

export const authBaseURL =
  process.env.REACT_APP_AUTH_SERVICE_API_URL ||
  'https://auth.staging.svc.avenue8.com'
